import {
  getGroupsData,
  getGroupDetailData,
  editGruopData,
  countEmailData,
  downloadGroupData,
  addGroupImageData,
  getGroupAmountInfoData,
  downloadGroupInfoData,
  editGroupLoggedData,
  editGroupShopStatusData,
  updateGochiKidDonateFlagData,
  editGroupGochiKidFlagShopData,
  getGroupCampaignAmountInfoData,
  updateGroupSettingGochiKidUnlimitData,
  editGroupGochiKidMenuPriceShopData,
  getGroupGochiKidAmountInfoData
} from '../libs/apis/GroupApi';

export const GET_GROUPS_REQUEST = 'GET_GROUPS_REQUEST';
export const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';
export const GET_GROUPS_FAILURE = 'GET_GROUPS_FAILURE';

export const GET_GROUP_DETAIL_REQUEST = 'GET_GROUP_DETAIL_REQUEST';
export const GET_GROUP_DETAIL_SUCCESS = 'GET_GROUP_DETAIL_SUCCESS';
export const GET_GROUP_DETAIL_FAILURE = 'GET_GROUP_DETAIL_FAILURE';

export const EDIT_GROUP_REQUEST = 'EDIT_GROUP_REQUEST';
export const EDIT_GROUP_SUCCESS = 'EDIT_GROUP_SUCCESS';
export const EDIT_GROUP_FAILURE = 'EDIT_GROUP_FAILURE';

export const COUNT_GROUP_EMAIL_REQUEST = 'COUNT_GROUP_EMAIL_REQUEST';
export const COUNT_GROUP_EMAIL_SUCCESS = 'COUNT_GROUP_EMAIL_SUCCESS';
export const COUNT_GROUP_EMAIL_FAILURE = 'COUNT_GROUP_EMAIL_FAILURE';

export const DOWNLOAD_GROUP_REQUEST = 'DOWNLOAD_GROUP_REQUEST';
export const DOWNLOAD_GROUP_SUCCESS = 'DOWNLOAD_GROUP_SUCCESS';
export const DOWNLOAD_GROUP_FAILURE = 'DOWNLOAD_GROUP_FAILURE';

export const DOWNLOAD_GROUP_INFO_REQUEST = 'DOWNLOAD_GROUP_REQUEST';
export const DOWNLOAD_GROUP_INFO_SUCCESS = 'DOWNLOAD_GROUP_SUCCESS';
export const DOWNLOAD_GROUP_INFO_FAILURE = 'DOWNLOAD_GROUP_FAILURE';

export const ADD_GROUP_IMAGE_REQUEST = 'ADD_GROUP_IMAGE_REQUEST';
export const ADD_GROUP_IMAGE_SUCCESS = 'ADD_GROUP_IMAGE_SUCCESS';
export const ADD_GROUP_IMAGE_FAILURE = 'ADD_GROUP_IMAGE_FAILURE';

export const GET_GROUP_AMOUNT_REQUEST = 'GET_GROUP_AMOUNT_REQUEST';
export const GET_GROUP_AMOUNT_SUCCESS = 'GET_GROUP_AMOUNT_SUCCESS';
export const GET_GROUP_AMOUNT_FAILURE = 'GET_GROUP_AMOUNT_FAILURE';

export const EDIT_GROUP_LOGGED_REQUEST = 'EDIT_GROUP_LOGGED_REQUEST';
export const EDIT_GROUP_LOGGED_SUCCESS = 'EDIT_GROUP_LOGGED_SUCCESS';
export const EDIT_GROUP_LOGGED_FAILURE = 'EDIT_GROUP_LOGGED_FAILURE';

export const EDIT_GROUP_SHOP_STATUS_REQUEST = 'EDIT_GROUP_SHOP_STATUS_REQUEST';
export const EDIT_GROUP_SHOP_STATUS_SUCCESS = 'EDIT_GROUP_SHOP_STATUS_SUCCESS';
export const EDIT_GROUP_SHOP_STATUS_FAILURE = 'EDIT_GROUP_SHOP_STATUS_FAILURE';

export const UPDATE_GOCHI_KID_DONATE_FLAG_REQUEST =
  'UPDATE_GOCHI_KID_DONATE_FLAG_REQUEST';
export const UPDATE_GOCHI_KID_DONATE_FLAG_SUCCESS =
  'UPDATE_GOCHI_KID_DONATE_FLAG_SUCCESS';
export const UPDATE_GOCHI_KID_DONATE_FLAG_FAILURE =
  'UPDATE_GOCHI_KID_DONATE_FLAG_FAILURE';

export const EDIT_GROUP_GOCHI_KID_FLAG_SHOP_REQUEST =
  'EDIT_GROUP_GOCHI_KID_FLAG_SHOP_REQUEST';
export const EDIT_GROUP_GOCHI_KID_FLAG_SHOP_SUCCESS =
  'EDIT_GROUP_GOCHI_KID_FLAG_SHOP_SUCCESS';
export const EDIT_GROUP_GOCHI_KID_FLAG_SHOP_FAILURE =
  'EDIT_GROUP_GOCHI_KID_FLAG_SHOP_FAILURE';

export const UPDATE_GROUP_SETTING_GOCHI_KID_UNLIMIT_REQUEST =
  'UPDATE_GROUP_SETTING_GOCHI_KID_UNLIMIT_REQUEST';
export const UPDATE_GROUP_SETTING_GOCHI_KID_UNLIMIT_SUCCESS =
  'UPDATE_GROUP_SETTING_GOCHI_KID_UNLIMIT_SUCCESS';
export const UPDATE_GROUP_SETTING_GOCHI_KID_UNLIMIT_FAILURE =
  'UPDATE_GROUP_SETTING_GOCHI_KID_UNLIMIT_FAILURE';

export const EDIT_GROUP_GOCHI_KID_MENU_PRICE_SHOP_REQUEST =
  'EDIT_GROUP_GOCHI_KID_MENU_PRICE_SHOP_REQUEST';
export const EDIT_GROUP_GOCHI_KID_MENU_PRICE_SHOP_SUCCESS =
  'EDIT_GROUP_GOCHI_KID_MENU_PRICE_SHOP_SUCCESS';
export const EDIT_GROUP_GOCHI_KID_MENU_PRICE_SHOP_FAILURE =
  'EDIT_GROUP_GOCHI_KID_MENU_PRICE_SHOP_FAILURE';

export const getGroups = params => dispatch => {
  dispatch({ type: GET_GROUPS_REQUEST });
  return getGroupsData(params)
    .then(response =>
      dispatch({
        type: GET_GROUPS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GROUPS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGroupDetail = groupId => dispatch => {
  dispatch({ type: GET_GROUP_DETAIL_REQUEST });
  return getGroupDetailData(groupId)
    .then(response =>
      dispatch({
        type: GET_GROUP_DETAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GROUP_DETAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editGroup = (groupId, params) => dispatch => {
  dispatch({ type: EDIT_GROUP_REQUEST });
  return editGruopData(groupId, params)
    .then(response =>
      dispatch({
        type: EDIT_GROUP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_GROUP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const countGroupEmail = email => dispatch => {
  dispatch({ type: COUNT_GROUP_EMAIL_REQUEST });
  return countEmailData({ email })
    .then(response =>
      dispatch({
        type: COUNT_GROUP_EMAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: COUNT_GROUP_EMAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadGroup = params => dispatch => {
  dispatch({ type: DOWNLOAD_GROUP_REQUEST });
  return downloadGroupData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_GROUP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_GROUP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadGroupInfo = params => dispatch => {
  dispatch({ type: DOWNLOAD_GROUP_INFO_REQUEST });
  return downloadGroupInfoData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_GROUP_INFO_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_GROUP_INFO_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addGroupImage = (groupId, params) => dispatch => {
  dispatch({ type: ADD_GROUP_IMAGE_REQUEST });
  return addGroupImageData(groupId, params)
    .then(response =>
      dispatch({
        type: ADD_GROUP_IMAGE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GROUP_IMAGE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGroupAmountInfo = () => dispatch => {
  dispatch({ type: GET_GROUP_AMOUNT_REQUEST });
  return getGroupAmountInfoData()
    .then(response =>
      dispatch({
        type: GET_GROUP_AMOUNT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GROUP_AMOUNT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editGroupLogged = (groupId, params) => dispatch => {
  dispatch({ type: EDIT_GROUP_LOGGED_REQUEST });
  return editGroupLoggedData(groupId, params)
    .then(response =>
      dispatch({
        type: EDIT_GROUP_LOGGED_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_GROUP_LOGGED_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editGroupShopStatus = (groupId, params) => dispatch => {
  dispatch({ type: EDIT_GROUP_SHOP_STATUS_REQUEST });
  return editGroupShopStatusData(groupId, params)
    .then(response =>
      dispatch({
        type: EDIT_GROUP_SHOP_STATUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_GROUP_SHOP_STATUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const updateGochiKidDonateFlag = (groupId, params) => dispatch => {
  dispatch({ type: UPDATE_GOCHI_KID_DONATE_FLAG_REQUEST });
  return updateGochiKidDonateFlagData(groupId, params)
    .then(response =>
      dispatch({
        type: UPDATE_GOCHI_KID_DONATE_FLAG_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: UPDATE_GOCHI_KID_DONATE_FLAG_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editGroupGochiKidFlagShop = (groupId, params) => dispatch => {
  dispatch({ type: EDIT_GROUP_GOCHI_KID_FLAG_SHOP_REQUEST });
  return editGroupGochiKidFlagShopData(groupId, params)
    .then(response =>
      dispatch({
        type: EDIT_GROUP_GOCHI_KID_FLAG_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_GROUP_GOCHI_KID_FLAG_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGroupCampaignAmountInfo = () => dispatch => {
  dispatch({ type: GET_GROUP_AMOUNT_REQUEST });
  return getGroupCampaignAmountInfoData()
    .then(response =>
      dispatch({
        type: GET_GROUP_AMOUNT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GROUP_AMOUNT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const updateGroupSettingGochiKidUnlimit = (
  groupId,
  params
) => dispatch => {
  dispatch({ type: UPDATE_GROUP_SETTING_GOCHI_KID_UNLIMIT_REQUEST });
  return updateGroupSettingGochiKidUnlimitData(groupId, params)
    .then(response =>
      dispatch({
        type: UPDATE_GROUP_SETTING_GOCHI_KID_UNLIMIT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: UPDATE_GROUP_SETTING_GOCHI_KID_UNLIMIT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editGroupGochiKidMenuPriceShop = (groupId, params) => dispatch => {
  dispatch({ type: EDIT_GROUP_GOCHI_KID_MENU_PRICE_SHOP_REQUEST });
  return editGroupGochiKidMenuPriceShopData(groupId, params)
    .then(response =>
      dispatch({
        type: EDIT_GROUP_GOCHI_KID_MENU_PRICE_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_GROUP_GOCHI_KID_MENU_PRICE_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGroupGochiKidAmountInfo = () => dispatch => {
  dispatch({ type: GET_GROUP_AMOUNT_REQUEST });
  return getGroupGochiKidAmountInfoData()
    .then(response =>
      dispatch({
        type: GET_GROUP_AMOUNT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GROUP_AMOUNT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
